import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import loadable from '@loadable/component'
import config from 'constants/config'
import { connect } from 'react-redux'
import { isActiveLuxuryPlusMember } from 'loyalty/selectors/featureToggle'
import LuxuryPlusLabel from 'loyalty/components/LuxuryPlusLabel'
import Caption from 'components/Luxkit/Typography/Caption'
import { ResponsiveLogoProps } from './logos/ResponsiveLuxuryEscapesLogo'

const logos = {
  cudo: loadable(() => import(/* webpackChunkName: "CudoGetawaysLogo" */ './logos/CudoGetawaysLogo')),
  cudotravel: loadable(() => import(/* webpackChunkName: "CudoTravellogo" */ './logos/CudoTravelLogo')),
  ouffer: loadable(() => import(/* webpackChunkName: "Oufferlogo" */ './logos/OufferGetawaysLogo')),
  deals: loadable(() => import(/* webpackChunkName: "Dealslogo" */ './logos/DealsGetawaysLogo')),
  dealstravel: loadable(() => import(/* webpackChunkName: "DealsTravellogo" */ './logos/DealsTravelLogo')),
  livingsocial: loadable(() => import(/* webpackChunkName: "LivingSociallogo" */ './logos/LivingsocialGetawaysLogo')),
  treatme: loadable(() => import(/* webpackChunkName: "TreatMelogo" */ './logos/TreatmeLogo')),
  treatmetravel: loadable(() => import(/* webpackChunkName: "TreatMeTravellogo" */ './logos/TreatmeTravelLogo')),
  luxuryescapes: loadable(() => import(/* webpackChunkName: "ResponsiveLuxuryEscapesLogo" */ './logos/ResponsiveLuxuryEscapesLogo')),
  scoopon: loadable(() => import(/* webpackChunkName: "Scooponlogo" */ './logos/ScooponLogo')),
  lebusinesstraveller: loadable(() => import(/* webpackChunkName: "LeBusinessTravellerLogo" */ './logos/LeBusinessTravellerLogo')),
  leagenthub: loadable(() => import(/* webpackChunkName: "LeAgentHubLogo" */ './logos/LeAgentHubLogo')),
}

const LogoComponent = styled.div<{height: number, width: number}>`
  max-height: ${({ height }) => rem(height)};
  max-width: ${({ width }) => rem(width)};
`

type Props = {
  className?: string;
  isLuxuryPlusMember: boolean;
  fill?: string;
} & ResponsiveLogoProps

function LogoIcon(props: Props) {
  const {
    className,
    fill,
    isLuxuryPlusMember,
    mobileVariant,
    tabletVariant,
    desktopVariant,
  } = props

  const Logo = logos[config.logo.icon]

  return (
    <>
      <LogoComponent
        className={className}
        as={Logo}
        aria-hidden="true"
        height={config.logo.iconHeight || null}
        width={config.logo.iconWidth || null}
        fill={fill || config.logo.fillColor}
        // Why the conditional spread?
        // Because only ResponsiveLuxuryEscapesLogo understands it.
        {...(config.BRAND === 'luxuryescapes' ? { mobileVariant, tabletVariant, desktopVariant } : {})}
      />
      {isLuxuryPlusMember && <LuxuryPlusLabel>
        <Caption variant="large" weight="bold">plus+</Caption>
      </LuxuryPlusLabel>}
    </>
  )
}

const mapStateToProps = (state: App.State) => ({
  isLuxuryPlusMember: isActiveLuxuryPlusMember(state),
})

export default connect(mapStateToProps)(React.memo(LogoIcon))
